const TM = 'CloudConnexa';

export const errorMessages = {
    '0-10-1': 'Must be false',
    '0-10-2': 'Must be true',
    '0-10-3': 'Must be less than',
    '0-10-4': 'Must be greater than',
    '0-10-5': 'Numeric value out of bounds',
    '0-10-6': 'Must be a well-formed email address',
    '0-10-7': 'Must be a future date',
    '0-10-8': 'Must be a date in the present or in the future',
    '0-10-9': 'Must be less than or equal to {value}',
    '0-10-10': 'Must be greater than or equal to {value}',
    '0-10-11': 'Must be less than 0',
    '0-10-12': 'Must be less than or equal to 0',
    '0-10-13': 'Must not be empty',
    '0-10-14': 'Must be null',
    '0-10-15': 'Must be a past date',
    '0-10-16': 'Must be a date in the past or in the present',
    '0-10-17': 'Invalid format',
    '0-10-25': 'Length must be between {min} and {max}',
    '0-10-46': '{value} cannot be used',
    '0-10-47': 'Contains restricted symbols',
    '0-10-48': 'Provided json is invalid',
    '0-10-49': "The value '{invalidValue}' is invalid. Allowed value(s): {allowedValue}",
    '0-11-1': 'Invalid notification type',
    '0-11-2': 'Invalid service type',
    '0-11-3': 'Invalid setting type',
    '0-11-4': 'Invalid setting value',
    '0-11-5': 'Subnet should have mask specified',
    '0-11-6': 'Subnet should have mask length specified correctly',
    '0-11-7': 'IP address has invalid mask',
    '0-11-8': 'IP address has invalid format',
    '0-11-9': 'Domain has invalid format',
    '0-11-10': 'System update is in progress. Please try again later.',
    '0-11-11': 'Entity was changed in parallel session. Reload the page and try again.',
    '0-11-12': 'Transaction failed. Please try again.',
    '2-12': 'Validation failed.',
    '2-0-0': 'Unpredicted error occurred.',
    '2-3-2': 'Cert Profile error occurred',
    '2-3-3': 'Billing error occurred',
    '2-3-4': 'SSO error occurred',
    '2-3-7': 'Cannot find notifications',
    '2-3-10': 'Cannot perform LDAP Authentication. Please try again later',
    '2-3-11': 'Public certificate has invalid format.',
    '2-11-1': 'Unauthorized',
    '2-11-2': 'Access denied',
    '2-11-6': 'No SSO token found',
    '2-12-1': 'Request validation failed',
    '2-12-3': 'The account has been suspended',
    '2-12-4': 'Email address is not valid.',
    '2-12-5': 'Account does not exist.',
    '2-12-8': 'You cannot use a password you have recently used',
    '2-12-9': 'User with given credentials does not exist',
    '2-12-11': 'Invalid web auth parameters',
    '2-12-14': 'Domain is already occupied',
    '2-12-15': 'Operation is restricted due to settings',
    '2-12-16': 'Device limit is exceeded',
    '2-12-19': 'Password is invalid',
    '2-12-21': 'MFA code is invalid',
    '2-12-22': 'Generation in progress...',
    '2-12-23': 'Owner of the domain was not found',
    '2-12-25': 'Unable to find default group',
    '2-12-26': 'Unable to find group',
    '2-12-28': 'IDP configuration was not found',
    '2-12-29': 'Domain auth config is not valid',
    '2-12-31': "Connection status '{option}' is not supported",
    '2-12-33': 'Cannot resend the invitation to the user without email',
    '2-12-34': "'node_id' was not provided or incorrect",
    '2-12-35': "'sso_id' was not provided or incorrect",
    '2-12-36': "'user_id' was not provided or incorrect",
    '2-12-37': "'tenant_id' was not provided or incorrect",
    '2-12-38': 'Route {route} has invalid format',
    '2-12-39': 'Invited status cannot be set after member activation',
    '2-12-40': 'Invited status cannot be changed until member accept invitation',
    '2-12-43': 'Activation data was not found',
    '2-12-44':
        "Invitation email wasn't sent to member '{username}'. Resend is prohibited, wait {delay} minute(s)",
    '2-12-45': 'Entity was not found',
    '2-12-46': 'Provided value is incorrect',
    '2-12-47': 'User cannot download Profiles, Device management is restricted',
    '2-12-48': 'User cannot download Profiles, Device management is restricted',
    '2-12-49': "User doesn't exist",
    '2-12-50': 'Cannot change 2FA configuration for not active user.',
    '2-12-51': 'Cannot change 2FA configuration for this user. Please change it on SSO',
    '2-12-52': 'Split Tunnel Off cannot be selected, if there is no Internet Gateway (Egress)',
    '2-12-53': 'Such access to the internet cannot be selected',
    '2-12-54':
        'IP Address must belong to Network Subnet or must be equal to VPN IP of Host Connector',
    '2-12-55': 'Network item id should be present',
    '2-12-56': 'Max Device number for User Group should be less than limit',
    '2-12-57': 'Max Device number for User Group should be greater than limit',
    '2-12-58': 'Name for system User Group is read only',
    '2-12-59': 'At least one value should be present: vpnRegionIds or allRegionsIncluded: true',
    '2-12-61': 'Gateway(s) does not exist',
    '2-15-2': 'ID generation failed',
    '9-0-0': 'Unpredicted error occurred',
    '9-3-1': `Cannot generate CloudFormation template. Please contact ${TM} support`,
    '9-3-2': `Cannot bundle Profile. Please contact ${TM} support`,
    '9-3-3': `Cannot generate token. Please contact ${TM} support`,
    '9-3-4': `Cannot generate Azure template. Please contact ${TM} support`,
    '9-3-5': `Cannot generate egress template. Please contact ${TM} support`,
    '9-11-1': 'Request validation failed',
    '9-11-2': 'Cannot delete last connector',
    '9-11-3':
        'Cannot delete connector for host, because it is used in DNS configuration. Please update DNS configuration in Settings first',
    '9-11-4':
        'Cannot delete connector, because it is used by LDAP Server. Please update LDAP configuration first',
    '9-11-5': 'Route {route} has invalid format',
    '9-11-6': 'Entity does not exist',
    '9-11-7': 'Entity already exists',
    '9-11-8': 'Value is incorrect',
    '9-11-9': 'Such access to the internet cannot be selected',
    '9-11-10': 'Split Tunnel Off cannot be selected, if there is no Internet Gateway (Egress)',
    '9-11-11': '{domain} is already used by another Network',
    '9-11-12': '{domain} is already used by another Network Application',
    '9-11-13': '{domain} is already used by another Host',
    '9-11-14':
        'Cannot delete network, because it is used in DNS configuration. Please update DNS configuration in Settings first',
    '9-11-15':
        'You cannot delete or update Route(s) [{routes}] that are used by the Source Service(s). You need to delete or update Source Services with Network Route(s)',
    '9-11-16':
        'You cannot delete or update Subnet(s) [{routes}] that are used by the IP Service(s). You need to delete or update IP Services with Network Subnet(s)',
    '9-11-17':
        "Cannot delete range '{route}', because it is used in DNS configuration. Please update DNS configuration in Settings first",
    '9-11-18':
        "Cannot delete range '{route}', because it contains LDAP Server. Please update LDAP configuration first",
    '9-11-19':
        'Cannot delete host, because it is used in DNS configuration. Please update DNS configuration in Settings first',
    '9-11-20': 'IP v4 addresses for VPN subnet and Split subnet should not be overlapped',
    '9-11-21': 'IP v6 addresses for VPN subnet and Split subnet should not be overlapped',
    '9-11-22': 'IP v4 address should not overlap with Connectors Split Subnet',
    '9-11-23': 'IP v6 address should not overlap with Connectors Split Subnet',
    '9-11-24':
        'Provided IP v4 address mask {mask} can not be greater than {maxMask} for Split subnet.',
    '9-11-25':
        'Provided IP v6 address mask {mask} can not be greater than {maxMask} for Split subnet.',
    '9-11-26': 'Name is taken',
    '9-11-27': 'Cannot delete last route',
    '9-11-28': 'Routes contain mixed types',
    '9-11-29': 'Service configuration should not be provided for IP source type',
    '9-11-30': 'Domains cannot be used for IP source type',
    '9-11-31': 'Service configuration should be provided for destination type',
    '9-11-32': 'Host Service cannot have IP source type',
    '9-11-33': 'Host Service cannot have routes',
    '9-11-34': '{type} {name} duplicates another one',
    '9-11-35': 'The IPv4 split subnet overlaps with network routes',
    '9-11-36': 'The IPv6 split subnet overlaps with network routes',
    '9-11-37': 'Domain is not valid',
    '9-11-38': 'At least 1 IP address should be added',
    '9-11-39': 'IP address is duplicated',
    '9-11-41': 'Gateway(s) does not exist',
    '9-11-42': 'Size must be between 1 and 50',
    '9-11-43': 'The subnet {subnet} overlaps with an existing one',
    '9-11-44': 'The domain {domain} overlaps with an existing one',
    '9-11-45': 'IP subnet is not valid',
    '9-11-46': 'The subnet contains non-routable addresses and cannot be set on a network',
    '9-11-47': 'The parameter is not allowed here',
    '9-11-48': 'Service type should be either ANY or some of the predefined ones',
    '9-11-49':
        'Service type CUSTOM should be selected in case custom service protocol and port/icmp type are provided',
    '9-11-50':
        'Custom service protocol and port/icmp type should be provided in case service type CUSTOM is selected',
    '9-11-51': 'There should be no more than one custom service type per protocol',
    '9-11-52': 'Port should not be provided for ICMP protocol and CUSTOM service type',
    '9-11-53': 'There are maximum 5 icmp types allowed',
    '9-11-54': 'ICMP type range is invalid',
    '9-11-55': 'ICMP type should not be provided unless ICMP protocol and CUSTOM service type set',
    '9-11-56': 'Port range is invalid',
    '9-11-57':
        'There is no Route created for specified IP Address or Subnet. Create Route which include this IP Address or Subnet first',
    '9-11-58':
        'There is no Route created for specified IP Address or Subnet. Create Route which include this IP Address or Subnet first',
    '9-11-59': 'Egress or Route(s) must be defined',
    '9-11-60': 'Only description can be updated for shared service',
    '9-11-61':
        'The {entity} is shared. You need to delete the subscriptions and invitations associated with this application prior to the deletion of the {entity}',
    '9-11-62':
        'One of your applications is shared. You need to delete the subscriptions and invitations associated with this application prior to the deletion of the application',
    '9-11-63': 'There are no available addresses left. Consider changing the subnet configuration',
    '9-11-64':
        'Source Domain(s) [{routes}] must belong to Network Route(s) of the Network. Please update or delete Source prior updating Network Route',
    '9-11-65':
        'You cannot delete domain(s) [{routes}] that are used by the Domain Service(s). You need to delete or update Destination Services with Network Domain(s)',
    '9-11-66': 'Shared service domain cannot be changed',
    '9-11-67': 'Shared domain cannot be changed',
    '9-11-69': 'Host without domain cannot have applications',
    '9-11-70': 'At least 1 application or ip service should be added for {entity}',
    '9-11-72':
        'The following domain(s) overlaps with domain, shared with you by App Provider: {domains}. Use different domain or navigate to AppHub and delete corresponding App(s)',
    '9-11-74': '{type} certificate is invalid',
    '9-11-75': 'Private key cannot be decrypted with provided passphrase',
    '9-11-76': 'Private key is not matching peer certificate',
    '9-11-77': 'Paired connector name {name} is taken',
    '9-11-79': 'Paired connector created already',
    '9-11-80': 'DeadPeerHandling must be RESTART for AWS',
    '9-11-81': 'StartupAction must be START for AWS',
    '9-11-82': 'Phase 2 lifetime must be less than phase 1 lifetime',
    '9-11-83': 'Rekey margin time must be less than Phase2.lifetime * 0.5',
    '9-11-84': 'Pre-shared key is required for SHARED_SECRET authentication',
    '9-11-85': 'Peer certificate is required for CERTIFICATE authentication',
    '9-11-86': 'Peer certificate private key is required for CERTIFICATE authentication',
    '9-11-87': 'Conflict with AWS reserved CIDR block',
    '9-11-88': 'Tunnel IP is not in range allowed by AWS',
    '9-11-89': 'Tunnel IP is not /30 block',
    '9-11-91': 'Tunnel IP overlaps with other IPSEC config',
    '9-11-93': 'Connector name max length exceeded',
    '9-11-94': 'VPN subnet should not be overlapped',
    '9-11-95': 'Remote Site IP overlaps with other IPSEC config',
    '9-11-96': 'CA certificate is required for CERTIFICATE authentication',
    '9-11-97': 'Remote Gateway certificate is required for CERTIFICATE authentication',
    '9-11-98':
        "Hostname and Domain can't be saved. Ensure they are correct and unique, or contact support for help",
    '9-12-1': 'ID generation failed',
    '10-0-0': 'Unpredicted error occurred',
    '10-3-0': 'External communication error',
    '10-3-2': "The operation can't be completed at the moment. Try again later.",
    '10-11-1': 'Request validation failed',
    '10-11-2': 'Value for the setting is not valid',
    '10-11-3': 'The value cannot be less than min Device limit configured',
    '10-11-4': 'The value cannot be more than max Device limit configured',
    '10-11-5': 'The value cannot be less than min authentication timeout limit configured',
    '10-11-6': 'The value cannot be more than max authentication timeout limit configured',
    '10-11-7': 'Region does not exist',
    '10-11-8': 'Entity does not exist',
    '10-11-9': 'IPv4 subnet should be provided',
    '10-11-10': 'IPv6 subnet should be provided',
    '10-11-11': 'The value cannot be less than min vpn session timeout limit configured',
    '10-11-12': 'The value cannot be more than max vpn session timeout limit configured',
    '10-11-13': 'The number of options cannot be more than max client options number configured',
    '10-11-14': 'Domain has invalid format',
    '10-11-15': 'Name {name} is duplicated',
    '10-11-16': 'Maximum {number} unique IP addresses for DNS servers are allowed',
    '10-11-17': 'Address has invalid format',
    '10-11-18': 'Address {address} is duplicated',
    '10-11-19': 'Dns zone cannot have empty routes list',
    '10-11-20': 'Maximum {number} DNS servers can be selected per zone',
    '10-11-21': 'Provided IPv4 subnets overlap',
    '10-11-22': 'Provided IPv6 subnets overlap',
    '10-11-23': 'The setting should be OFF to update primary or secondary dns ip address',
    '10-11-24': 'DNS IPv6 addresses are not supported yet',
    '10-11-25': 'The setting value for DNS IP v4 should not be the same for primary and secondary',
    '10-11-26': 'DNS addresses should be provided',
    '10-11-27': 'Primary DNS IPv4 address should be provided',
    '10-11-28': 'Device IP cannot be selected for DNS',
    '10-11-29': 'IP v4 addresses for VPN subnet and Split subnet should not be overlapped',
    '10-11-30': 'IP v6 addresses for VPN subnet and Split subnet should not be overlapped',
    '10-11-31':
        'Cannot update VPN Subnet for Devices and Connectors, because new subnet does not have enough IP addresses for current VPN configuration. Please specify bigger subnet',
    '10-11-32': 'IP v4 address should not overlap with Network Subnet',
    '10-11-33': 'IP v6 address should not overlap with Network Subnet',
    '10-11-34':
        'Device IP cannot be overlapped with DNS. Please update DNS configuration in Settings first',
    '10-11-35':
        "Provided IP v4 address mask '{mask}' can not be greater than {maxMask} for VPN subnet",
    '10-11-36':
        "Provided IP v6 address mask '{mask}' can not be greater than {maxMask} for VPN subnet",
    '10-11-37':
        "Provided IP v4 address mask '{mask}' can not be greater than {maxMask} for Split DNS subnet",
    '10-11-38':
        "Provided IP v6 address mask '{mask}' can not be greater than {maxMask} for Split DNS subnet",
    '10-11-39': 'IP v4 address is restricted to use for VPN subnet, try different subnet(mask)',
    '10-11-40': 'IP v6 address is restricted to use for VPN subnet, try different subnet(mask)',
    '10-11-41': 'Value should be between {min} and {max}',
    '10-11-42': 'Failed to process your request. Please try again later or contact our support',
    '11-0-0': 'Unpredicted error occurred',
    '11-3-0': 'External communication error',
    '11-11-1': 'Request validation failed',
    '11-11-2': 'Entity does not exist',
    '11-11-3': 'Entity already exists',
    '11-11-4': 'Provided value is incorrect',
    '12-0-0': 'Unpredicted error occurred.',
    '12-3-0': 'External communication error',
    '12-11-1': 'Request validation failed',
    '12-11-2': 'Entity does not exist',
    '12-11-3': 'Entity already exists',
    '12-11-4': 'Provided value is incorrect',
    '12-11-5':
        'Parent entity identifier should be provided for source access item if not all covered',
    '12-11-6': 'Identifiers should be provided for source access item in case ALL is not selected',
    '12-11-7': 'Identifiers should not be provided for source access item in case ALL is selected',
    '12-11-8':
        'Parent entity identifier should be provided for destination access item if not all covered',
    '12-11-9':
        'Identifiers should be provided for destination access item in case ALL is not selected',
    '12-11-10':
        'Identifiers should not be provided for destination access item in case ALL is selected',
    '12-11-11': 'Name is taken',
    '12-11-12': 'Last access group cannot be deleted',
    '12-11-13': 'You’ve reached a limit of 500 Access Groups. Please contact support',
    '13-0-0': 'Unpredicted error occurred',
    '13-3-0': 'External communication error',
    '13-11-1': 'Request validation failed',
    '14-3': 'External communication error.',
    '14-0-0': 'Unpredicted error occurred',
    '14-3-0': 'External communication error.',
    '14-11-1': 'Request validation failed',
    '14-11-2':
        '{address} cannot be used as DNS server. You can only specify public IP address, IP address from network’s subnet or Host Connector IP address',
    '14-11-3':
        '{subnet} belongs to Network VPN Subnet. Network Connector cannot be selected as DNS server. Please select an IP Address from Network Subnet',
    '14-11-4':
        '{subnet} belongs to User Group VPN Subnet. Device cannot be selected as DNS server. Please select an IP Address from Network Subnet or Host Connector',
    '14-11-5': 'Private IPs cannot be used as DNS server, if they are not defined under Network',
    '14-11-6':
        "IP reserved subnet '{reservedSubnet}' is not in range of full subnet '{subnet}' for {type} and {version}",
    '14-11-7':
        'There is no available VPN IP address left. Please update your Settings. You can extend the existing VPN Subnet or add a new one',
    '14-12-1': 'IP generation failed',
    '14-12-2': 'IP generation in progress...',
    '16-0-0': 'Unpredicted error occurred.',
    '16-3-0': 'External communication error.',
    '16-11-1': 'Request validation failed.',
    '18-2': 'External communication error.',
    '18-0-0': 'Unpredicted error occurred.',
    '18-2-0': 'External communication error.',
    '18-11-1': 'Request validation failed',
    '18-11-2': "Bundled file wasn't found",
    '18-11-3': 'Bundling is in progress...',
    '18-11-4': "Template for region '{region}' and type '{type}' doesn't exist",
    '18-11-5': "Template for type '{type}' doesn't exist",
    '18-11-6': "Image with type '{type}' does not exist",
    '19-0-0': 'Unpredicted error occurred.',
    '19-2-0': 'External communication error',
    '19-11-1': 'Request validation failed',
    '19-11-2': 'Notification with name {name} already exists',
    '19-11-3': 'From cannot be after To',
    '20-0-0': 'Unpredicted error occurred.',
    '20-2-0': 'External communication error.',
    '20-11-1': 'Request validation failed.',
    '21-2': 'External communication error.',
    '21-15': 'System exception occurred.',
    '21-0-0': 'Unpredicted error occurred.',
    '21-2-0': 'External communication error.',
    '21-2-1': "The operation can't be completed at the moment. Try again later.",
    '21-2-2': 'Cert Profile error occurred',
    '21-2-4': 'SSO error occurred',
    '21-11-1': 'Request validation failed',
    '21-11-3': 'The account has been suspended',
    '21-11-4': 'Email address is not valid.',
    '21-11-5': 'Operation is restricted due to settings',
    '21-11-6': 'Device limit is exceeded',
    '21-11-7': 'Generation in progress...',
    '21-11-8': 'Password management is restricted',
    '21-11-9': 'Cannot resend the invitation to the user without email',
    '21-11-10': 'Invited status cannot be set after member activation',
    '21-11-11': 'Invited status cannot be changed until member accept invitation',
    '21-11-12': 'Temporary password should be generated before sending',
    '21-11-13': 'Activation data was not found',
    '21-11-14':
        "Invitation email wasn't sent to member. Resend is prohibited, wait {delay} minute(s)",
    '21-11-15': 'Entity was not found',
    '21-11-16': 'Provided value is incorrect',
    '21-11-17': 'User cannot download Profiles, Device management is restricted',
    '21-11-18': 'User cannot download Profiles, Device management is restricted',
    '21-11-19': "User doesn't exist",
    '21-11-20': 'Cannot change 2FA configuration for not active user.',
    '21-11-21': 'Cannot change 2FA configuration for this user. Please change it on SSO',
    '21-11-22': 'Split Tunnel Off cannot be selected, if there is no Internet Gateway (Egress)',
    '21-11-23': 'Such access to the internet cannot be selected',
    '21-11-24': 'Max Device number for User Group should be less than limit',
    '21-11-25': 'Max Device number for User Group should be greater than limit',
    '21-11-26': 'Name for system User Group is read only',
    '21-11-27': 'At least one value should be present: vpnRegionIds or allRegionsIncluded: true',
    '21-11-29': 'Gateway(s) does not exist',
    '21-11-30': 'Entity already exists',
    '21-11-31': 'Name is taken',
    '21-11-32': 'Region is not allowed to use',
    '21-11-33': 'Email is already in use',
    '21-11-34': 'Member management is restricted',
    '21-11-35': 'Username is taken',
    '21-11-36': 'Member cannot have such a role',
    '21-11-37': 'Email is mandatory for admins',
    '21-11-38': 'Email is mandatory',
    '21-11-39': 'Only existing members with active status can be promoted to admins',
    '21-11-40': 'Owner cannot be deleted',
    '21-11-41': 'You cannot delete your account',
    '21-11-42': 'Member cannot have such a role',
    '21-11-43': 'Member cannot be moved to group with less Devices allowed',
    '21-11-44': 'There are no available addresses left. Consider changing the subnet configuration',
    '21-11-45':
        'Client UUID should be provided in case Device Identity Verification and Enforcement (DIVE) is set to Enforce level',
    '21-11-46': 'Client UUID is taken',
    '21-11-48':
        'Untrusted device. Please check that you are using a correct device or contact your Administrator if you need help connecting.',
    '21-11-49': 'Unable to find default group',
    '21-11-50': 'Unable to find group',
    '21-11-51': 'Entity was not found',
    '21-11-52': 'Cannot perform LDAP Authentication. Please try again later',
    '21-11-53': 'Public certificate has invalid format.',
    '21-11-54':
        'IP Address must belong to Network Subnet or must be equal to VPN IP of Host Connector',
    '21-11-55': 'Network item id should be present',
    '21-11-56': 'Check type should be unique',
    '21-11-57': 'IP subnets should be unique',
    '21-11-58': 'Check type should match policy type',
    '21-11-59': 'Certificate length should be between {min} and {max}',
    '21-11-60': 'Certificate should be a valid PEM',
    '21-11-61': 'The certificate issuer has an invalid format',
    '21-11-62': 'Certificate is expired',
    '21-11-65': 'Unexpected antivirus type "{antivirus}"',
    '21-15-1': 'System exception occurred.',
    '21-15-2': 'System exception occurred.',
    '21-15-3': 'Configuration incorrect',
    '24-0-0': 'Unpredicted error occurred.',
    '24-3-0': 'External communication error.',
    '24-11-1': 'Request validation failed.',
    '28-0-0': 'Unpredicted error occurred.',
    '28-11-1': 'Unauthorized',
    '28-11-2': 'Access denied',
    '28-12-1': 'Request validation failed',
    '28-15-2': 'ID generation failed',
    '29-3-1': "The operation can't be completed at the moment. Try again later.",
    '29-12-22': 'Generation in progress...',
    '34-3-0': 'External communication error',

    // SSO error codes
    '3-12-1': 'Request validation failed',
    '3-12-4': 'Username is taken',
    '3-12-42': 'Invalid file format',
    '3-12-54': 'Provided value cannot be used',

    '3-16-8': 'Email is already in use',
    '3-16-10': 'Admin users must have an email address. Enter it and try again.',
    '3-16-11': 'Email address is not valid',
} as const;

function makeMessages<T extends Record<string, string> = Record<string, never>>(
    overrides?: T,
): typeof errorMessages & T;

function makeMessages<T extends Record<string, string>>(overrides?: T) {
    return { ...errorMessages, ...overrides };
}

export { makeMessages };
